module.exports = __webpack_public_path__ + "static/media/Coldiac-Regular.32efdf66.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Coldiac-Regular.otf
// module id = 2360
// module chunks = 49